import { createFeatureSelector, createSelector } from "@ngrx/store";


const selectLicenceFeature = createFeatureSelector<any>('licences');


export const selectAllLicence = createSelector(
  selectLicenceFeature,
  (state: any) => state
)